import httpDriver from 'app/utils/httpDriver';
import { TMutation, TQuery } from 'app/Requests/types';
import { apiRoutes } from 'reports/utils/apiRoutes';
import { constants } from 'reports/pages/AddTemplate/constants';

export const showReport = async ({ queryKey }: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.showReport, queryKey[1]);
  return data?.payload?.records;
};

export const storeReport = async (body: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.storeReport, body);
  return data?.payload?.records;
};

export const updateReport = async (body: TMutation): Promise<any> => {
  const { data } = await httpDriver.put(apiRoutes.updateReport, body);
  return data?.payload?.records;
};

export const activateReport = async (body: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.activateReport, body);
  return data?.payload?.records;
};

export const getActiveTemplates = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes.activeTemplates,
    queryKey[1]
  );
  return data?.payload?.records?.map((item: any) => ({
    value: item.id,
    label: item.name,
  }));
};

export const getActiveTemplatesDownload = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes.activeTemplatesDownload,
    queryKey[1]
  );
  return data?.payload?.records?.map((item: any) => ({
    value: item.id,
    label: item.name,
  }));
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getActiveTemplatesFastDownload = async ({ module_name }: any) => {
  const { data } = await httpDriver.post(apiRoutes.activeTemplatesDownload, {
    module_name,
  });
  return data?.payload?.records?.map((item: any) => ({
    value: item.id,
    label: item.name,
  }));
};

export const handleTrashTemplate = async ({
  id,
  module_name,
  successMessage,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.trashTemplate, {
    ids: [id],
    module_name: module_name,
  });
  return { ...data, successMessage };
};

export const handleCopyTemplate = async ({
  id,
  module_name,
  successMessage,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.copyTemplate, {
    template_id: id,
    module_name: module_name,
  });
  return { ...data, successMessage };
};

export const handleRestoreTemplate = async ({
  id,
  module_name,
  successMessage,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.restoreTemplate, {
    ids: [id],
    module_name: module_name,
  });
  return { ...data, successMessage };
};
export const handleDeleteTemplate = async ({
  id,
  module_name,
  successMessage,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.delete(apiRoutes.deleteTemplate, {
    data: { ids: [id], module_name: module_name },
  });
  return { ...data, successMessage };
};

export const getTemplate = async ({ queryKey }: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.getTemplate, {
    template_id: queryKey[1],
  });
  const isEntity = window.location.pathname.includes('ENTITIES');

  return {
    ...data?.payload?.records,
    selected_slugs:
      data?.payload?.records?.selected_slugs?.map((chart: any) =>
        chart.slug === constants.influencerInformation && isEntity
          ? {
              ...chart,
              name: 'ENTITY INFORMATION',
              name_ar: 'معلومات الكيان',
            }
          : chart
      ) || [],
  };
};
export const templateToReport = async ({ queryKey }: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes.getTemplateToReport,
    queryKey[1]
  );
  return data?.payload?.records;
};
export const getReportHistory = async ({ queryKey }: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes.getReportHistory,
    queryKey[1]
  );
  return data?.payload?.records;
};
export const getEditReportTableOptions = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes.getEditReportTableOptions,
    queryKey[1]
  );
  return data?.payload?.records;
};
export const getEditReportTableOptionsCount = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes.getEditReportTableOptionsCount,
    queryKey[1]
  );
  return data?.payload?.records.count;
};

export const getReportsVersionsCount = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes.reportsVersionsCount,
    queryKey[1]
  );
  return data?.payload?.count;
};

export const handleDeleteReport = async ({
  id,
  module_name,
  successMessage,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.delete(apiRoutes.deleteReports, {
    data: { ids: [id], module_name },
  });
  return { ...data, successMessage };
};
export const handleRestoreReport = async ({
  id,
  module_name,
  successMessage,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.restoreReports, {
    ids: [id],
    module_name,
  });
  return { ...data, successMessage };
};

export const handleTrashReport = async ({
  id,
  module_name,
  successMessage,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.trashReports, {
    ids: [id],
    module_name,
  });
  return { ...data, successMessage };
};

export const handelDeActiveReport = async ({
  id,
  template_id,
  successMessage,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.deActiveReport, {
    ids: [id],
    template_id: template_id,
  });
  return { ...data, successMessage };
};

export const handleDeactivateAllReport = async ({
  item_ids,
  module_name,
  successMessage,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.deActiveAllReport, {
    item_ids: item_ids,
    module_name: module_name,
  });
  return { ...data, successMessage };
};

export const handelActiveReport = async ({
  id,
  template_id,
  successMessage,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.activeReport, {
    ids: [id],
    template_id: template_id,
  });
  return { ...data, successMessage };
};
export const getModuleCharts = async ({ queryKey }: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.getModuleCharts, {
    module_name: queryKey[1],
    sub_module_name:queryKey[2]
  });
  const isEntity = window.location.pathname.includes('ENTITIES');

  return (
    data?.payload?.records.map((chart: any) =>
      chart.slug === constants.influencerInformation && isEntity
        ? {
            ...chart,
            name: 'ENTITY INFORMATION',
            name_ar: 'معلومات الكيان',
          }
        : chart
    ) || []
  );
};
export const getItemSortTypeOptions = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.getItemSortOptions, {
    module_name: queryKey[0],
  });
  return data?.payload?.records || [];
};
export const getTweetTypesOptions = async (): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.getTweetTypesOptions, {});
  return data?.payload?.records || [];
};
export const getInstagramPostsTypesOptions = async (): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.getInstagramPostsTypesOptions, {});
  return data?.payload?.records || [];
};
export const getPostsTypesOptions = async (): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.getPostsTypesOptions, {});
  return data?.payload?.records || [];
};

export const saveTemplate = async (body: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.saveTemplate, body);
  return data;
};
export const updateTemplate = async (body: TMutation): Promise<any> => {
  const { data } = await httpDriver.put(apiRoutes.updateTemplate, body);
  return data;
};
export const storeComment = async (body: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.storeComment, body);
  return data.payload.records;
};

export const deleteComment = async (body: TMutation): Promise<any> => {
  const { data } = await httpDriver.delete(apiRoutes.deleteComment, {
    data: body,
  });
  return data;
};
export const getDefaultHashtagsIds = async (): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.defaultHashtagsIds);
  return data?.payload?.records || [];
};
export const getDefaultInfluencersIds = async (): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.defaultInfluencersIds);
  return data?.payload || [];
};
// export const getInfInfoTypesOptions = async (): Promise<any> => {
//   const { data } = await httpDriver.post(apiRoutes.infInfoOptions);
//   return data?.payload?.records || [];
// };
